import React from "react";
import "./work.css";
import Card from "./Card";
import { Typography, Grid } from "@mui/material";

export default function () {

  const data = [
    {
      title: "GDSC",
      role: "Core Team Member",
      description: `GDSC is a Technical club that runs under the mentorship of google
    itself.`,
      duration: " July'21 - July'22",
      instagram: "#",
      linkedin: "#",
      website: "#",
    },
    {
      title: "Club IDE",
      role: "CP Lead",
      description:
        "Club IDE is a community of our college for the students by the student.",
      duration: "2021-2022",
      instagram: "#",
      linkedin: "#",
      website: "#",
    },
    {
      title: "CC Chapter",
      role: "President",
      description:
        "Club for competitive coders that runs under the mentorship of CodeChef.",
      duration: " Aug'21 - June'22",
      instagram: "#",
      linkedin: "#",
      website: "#",
    },
  ];
  return (
    <div align="center" className="work_section">
      <Typography
        variant="h4"
        color={"#fff"}
        align="center"
        sx={{ margin: "50px" }}>
        Work Experience
      </Typography>

      <Grid container align="center">
        {data.map((d) => (
          <Grid item xs={12} md={4}>
            <Card
              title={d.title}
              role={d.role}
              description={d.description}
              duration={d.duration}
              instagram={d.instagram}
              linkedin={d.linkedin}
              website={d.website}></Card>
          </Grid>
        ))}
      </Grid>
    </div>
  );
}
